import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {EaSourceFileService} from "../../../../../service/api/ea-source-file.service";
import {EaSourceFileDto} from "../../../../../model/dto/entity/ea-source-file.dto";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../core/shared/helper/widget-function-call-back-create";

@Component({
    selector: 'ea-project-source-files-tab',
    templateUrl: './ea-project-source-files-tab.component.html',
    standalone: false
})
export class EaProjectSourceFilesTabComponent implements OnInit, OnChanges, OnDestroy {

    @Input() objectIdentifier: ObjectIdentifier;

    initialized: boolean;
    sourceFilesWidget: WidgetData;
    selectedFile: EaSourceFileDto;
    previewData: any;

    constructor(
        protected sourceFileService: EaSourceFileService
    ) {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent(): void {
        this.refreshWidgets();
        this.initialized = true;
    }

    refreshWidgets(): void {
        if (!this.objectIdentifier?.objectId) {
            return;
        }

        const filterCriteria = FilterCriteria.create('project', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);
        this.sourceFilesWidget = WidgetFactory.createWidgetTableEntityBasicQl(
            'ea.project.source.files.widget',
            'Source Files',
            'ea.EaSourceFile',
            [filterCriteria]
        );

        const fields: WidgetToolbarCreateInterface[] = [{
            fieldName: 'projectDtoId',
            fieldValue: this.objectIdentifier.objectId
        }];
        this.sourceFilesWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }

    handleFileUploaded(file: EaSourceFileDto): void {
        this.refreshWidgets();
    }

    handleFileSelect(event: any): void {
        if (event?.data) {
            this.selectedFile = event.data;
            this.loadPreview(this.selectedFile.id);
        }
    }

    loadPreview(fileId: number): void {
        this.sourceFileService.getPreview(fileId).subscribe({
            next: (response) => {
                this.previewData = response;
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['objectIdentifier']) {
            this.refreshWidgets();
        }
    }

    ngOnDestroy(): void {
    }
}
